var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIconForDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_182398",
    "data-name": "Group 182398",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149783",
    "data-name": "Rectangle 149783",
    width: 29,
    height: 29,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "upload_725008",
    transform: "translate(6.133 4.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182385",
    "data-name": "Group 182385",
    transform: "translate(4.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182384",
    "data-name": "Group 182384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49751",
    "data-name": "Path 49751",
    d: "M137.724,5.151,133.4.211a.616.616,0,0,0-.929,0l-4.322,4.94a.617.617,0,0,0,.464,1.024h2.47V14.2a.618.618,0,0,0,.617.617h2.47a.618.618,0,0,0,.617-.617V6.175h2.47a.617.617,0,0,0,.464-1.024Z",
    transform: "translate(-127.998)",
    fill: "#7263d6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_182387",
    "data-name": "Group 182387",
    transform: "translate(0 13.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182386",
    "data-name": "Group 182386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49752",
    "data-name": "Path 49752",
    d: "M31.832,352V355.7h-13.4V352H16v4.94a1.226,1.226,0,0,0,1.218,1.235H33.05a1.225,1.225,0,0,0,1.218-1.235V352Z",
    transform: "translate(-16 -352)",
    fill: "#7263d6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconForDoc);
export default __webpack_public_path__ + "static/media/uploadIconForDoc.1f0c11b96ba3c6058c0c4ad7e52bc5dc.svg";
export { ForwardRef as ReactComponent };